// @ts-nocheck
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ButtonBase } from '@mui/material';

import styles from './ContactsMessage.module.css';
import { prepareWaId } from '@src/helpers/PhoneNumberHelper';
import CustomAvatar from '@src/components/CustomAvatar';
import ChatIcon from '@mui/icons-material/Chat';
import { getBaseRoute, generateInitialsHelper } from '@src/helpers/Helpers';

const ContactsMessage = ({ data }) => {
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const navigate = useNavigate();
	const { id } = useParams();
	const { contacts } = data?.payload || data?.resendPayload;

	const handleClick = (targetWaId) => {
		const waId = prepareWaId(targetWaId);
		navigate(`/${getBaseRoute(currentUser?.type)}/${id}/chat/${waId}`);
	};

	return (
		<div className={styles.root}>
			{contacts?.map((contact, contactIndex) => (
				<div key={contactIndex} className={styles.item}>
					<div className={styles.header}>
						<>
							<CustomAvatar
								className={styles.avatar}
								generateBgColorBy={contact.name?.formatted_name}
							>
								{generateInitialsHelper(contact.name?.formatted_name ?? '')}
							</CustomAvatar>
							<div key={contactIndex} className={styles.name}>
								{contact.name?.formatted_name ?? ''}
							</div>
						</>
					</div>
					<div className={styles.footer}>
						{contact.phones?.map((phoneObj, phoneObjIndex) => (
							<ButtonBase
								key={phoneObjIndex}
								className={styles.messageButton}
								onClick={() => handleClick(phoneObj.wa_id)}
							>
								<ChatIcon className={styles.messageButtonIcon} />
								<div className={styles.phoneNumberContainer}>
									{phoneObj?.type && <div className={styles.phoneNumberType}>{phoneObj.type}</div>}
									<div className={styles.phoneNumber}>{phoneObj.phone ?? phoneObj.wa_id}</div>
								</div>
							</ButtonBase>
						))}
					</div>
				</div>
			))}
		</div>
	);
};

export default ContactsMessage;
